// src/context/ModalHeaderContext.js

import React, { createContext, useState, useCallback } from 'react';

// 1️⃣ Definimos el contexto y un hook de uso.
export const ModalHeaderContext = createContext({
  // Devuelve el objeto { onSave, onCancel, onEdit, … } para el modal activo, o null si no hay nada.
  getHeaderActions: (modalId) => null,
  // Registra un conjunto de callbacks bajo un modalId concreto.
  registerHeaderActions: (modalId, actions) => {},
  // Quita cualquier callback asociado a ese modalId.
  unregisterHeaderActions: (modalId) => {},
});

// 2️⃣ Proveedor que envuelve a la app.
export const ModalHeaderProvider = ({ children }) => {
  // Mapeo interno: modalId → { onSave, onCancel, onEdit, … }
  const [actionsMap, setActionsMap] = useState({});

  // 3️⃣ Función para registrar callbacks para un modalId dado.
  const registerHeaderActions = useCallback((modalId, actions) => {
    setActionsMap(prev => {
      return {
        ...prev,
        [modalId]: actions
      };
    });
  }, []);

  // 4️⃣ Función para eliminar el modalId y sus callbacks.
  const unregisterHeaderActions = useCallback((modalId) => {
    setActionsMap(prev => {
      const copy = { ...prev };
      delete copy[modalId];
      return copy;
    });
  }, []);

  // 5️⃣ Función para recuperar los callbacks de un modalId (o null si no existe).
  const getHeaderActions = useCallback((modalId) => {
    return actionsMap[modalId] || null;
  }, [actionsMap]);

  return (
    <ModalHeaderContext.Provider value={{
      getHeaderActions,
      registerHeaderActions,
      unregisterHeaderActions
    }}>
      {children}
    </ModalHeaderContext.Provider>
  );
};
